import React, { useState } from 'react';
import { Avatar } from 'antd';

// AntD doesn't forward loading/decoding to its generated img. A node source
// keeps its existing sizing and initials while making the real image lazy.
export const LazyAvatar = React.forwardRef(function LazyAvatar({ src, children, ...props }, ref) {
  const [failed, setFailed] = useState(null);
  return <Avatar {...props} ref={ref} src={src && failed !== src ? <img src={src} alt="Agent avatar" loading="lazy" decoding="async"
    onError={() => setFailed(src)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : undefined}>{children}</Avatar>;
});
